let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Lzx5")).then(() => parcelRequire('fFjBZ'));